import React from "react";

import IconButton from "@material-ui/core/IconButton";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";

import useStyles from "./styles";

const MediaBasket = () => {
  const classes = useStyles();

  return (
    <div className={classes.mediaBasketRoot}>
      <div className={classes.header}>
        Add Photos / Videos&nbsp;
        <span className={classes.optionalText}>(optional)</span>
      </div>

      <div className={classes.mediaContainer}>
        <IconButton className={classes.addMediaButton}>
          <AddAPhotoIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default MediaBasket;
